import cn from 'classnames/bind';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import styles from './styles.styl';
import { useMediaQuery } from 'react-responsive';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { Button } from '@consta/uikit/Button';
import { IconBackward } from '@consta/uikit/IconBackward';
import { Tabs } from '@consta/uikit/Tabs';
import { tabsEditModal } from 'src/utils/config';
import { EitTabsModalEnum, InitTypeModalEnum } from 'src/utils/enum';
import { TextField } from '@consta/uikit/TextField';
import { DragNDropField } from '@consta/uikit/DragNDropField';
import { Loader } from '@consta/uikit/Loader';
import { IconTrash } from '@consta/uikit/IconTrash';
import { useDispatch } from 'react-redux';
import {
  addModelsIdle,
  loadAddModels,
} from 'src/redux/features/methodModels/addModels/actions';
import { useShallowEqualSelector } from 'src/customHooks/useShallowEqualSelector';
import {
  addModelsLoadedSelector,
  addModelsPendingSelector,
} from 'src/redux/features/methodModels/addModels/selectors';
import {
  editModelsLoadedSelector,
  editModelsPendingSelector,
} from 'src/redux/features/methodModels/editModels/selectors';
import { State } from 'src/redux/reducer';
import { loadAddImages } from 'src/redux/features/fs/addImages/actions';
import {
  addImagesIdSelector,
  addImagesLoadedSelector,
  addImagesPendingSelector,
} from 'src/redux/features/fs/addImages/selectors';
import {
  deleteImagesLoadedSelector,
  deleteImagesPendingSelector,
} from 'src/redux/features/fs/deleteImages/selectors';
import { loadDeleteImages } from 'src/redux/features/fs/deleteImages/actions';
import { intlFormat } from 'date-fns';
import { userInitSelector } from 'src/redux/features/userInit/selectors';
import { Select } from '@consta/uikit/Select';
import UserAddModal from '../UserAddModal';
import { loadOneModels } from 'src/redux/features/methodModels/oneModels/actions';
import {
  oneModelsLoadedSelector,
  oneModelsSelector,
} from 'src/redux/features/methodModels/oneModels/selectors';
import CenterLoader from '../CenterLoader';
import { formatDate } from 'src/utils';
import {
  editModelsIdle,
  loadEditModels,
} from 'src/redux/features/methodModels/editModels/actions';
import { loadAllModels } from 'src/redux/features/methodModels/allModels/actions';
import { loadAllUsers } from 'src/redux/features/users/allUsers/actions';
import {
  allUsersLoadedSelector,
  allUsersSelector,
} from 'src/redux/features/users/allUsers/selectors';
import { IAllUsersDataEnt } from 'src/redux/features/users/allUsers/types';
import { CloseModal } from '../CloseModal';
import { Modal } from '@consta/uikit/Modal';
import {
  deleteModelssIdle,
  loadDeleteModels,
} from 'src/redux/features/methodModels/deleteModels/actions';
import {
  deleteModelsLoadedSelector,
  deleteModelsPendingSelector,
} from 'src/redux/features/methodModels/deleteModels/selectors';

const cx = cn.bind(styles);

export interface IAddModalProps {
  setIsAddModal: (item: boolean) => void;
  isAddModal: boolean;
  isMyModal: boolean;
  modelId?: string;
  className?: string;
}

export interface Item {
  [id: string]: {
    id: string;
    description: string;
    version: number | string;
    date: Date;
    isNew?: boolean;
  };
}

const AddModal: React.FC<IAddModalProps> = ({
  className,
  setIsAddModal,
  isAddModal,
  isMyModal,
  modelId,
}) => {
  const refImage = useRef(null);

  const isMobile = useMediaQuery({ maxWidth: 460 });

  const dispatch = useDispatch();

  const [
    addModelsPending,
    editModelsPending,
    addImages,
    isLoadingAddImages,
    isPendingAddImages,
    isLoadingDeleteImages,
    isPendingDeleteImages,
    userInit,
    isLoadedOneModels,
    oneModels,
    isAddModelsLoaded,
    isEditModelsLoaded,
    isLoadedAllUser,
    allUsers,
    isLoadedDeleteModel,
    isPendingDeleteModel,
  ] = useShallowEqualSelector((state: State) => [
    addModelsPendingSelector(state),
    editModelsPendingSelector(state),
    addImagesIdSelector(state),
    addImagesLoadedSelector(state),
    addImagesPendingSelector(state),
    deleteImagesLoadedSelector(state),
    deleteImagesPendingSelector(state),
    userInitSelector(state),
    oneModelsLoadedSelector(state),
    oneModelsSelector(state),
    addModelsLoadedSelector(state),
    editModelsLoadedSelector(state),
    allUsersLoadedSelector(state),
    allUsersSelector(state),
    deleteModelsLoadedSelector(state),
    deleteModelsPendingSelector(state),
  ]);

  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const [deleteModal, setDeleteModal] = useState(null);

  const [valueTabs, setValueTabs] = useState(tabsEditModal[0]);

  const [titleModal, setTitleModal] = useState('');
  const [typeModal, setTypeModal] = useState(
    userInit.view_types_model.find(
      (item) => item.key === InitTypeModalEnum.ANY_LOGIC,
    ),
  );
  const [link, setLink] = useState(null);
  const [description, setDescription] = useState('');
  const [instruction, setInstruction] = useState('');
  const [image, setImage] = useState(null);
  const [isDisabledSaveButton, setIsDisabledSaveButton] = useState(true);
  const [versionInfo, setVersionInfo] = useState<Item>({});
  const [userModelData, setUserModelData] = useState<IAllUsersDataEnt[]>([]);

  useEffect(() => {
    if (isAddModelsLoaded || isEditModelsLoaded || isLoadedDeleteModel) {
      setIsAddModal(false);
      if (isMyModal) {
        dispatch(loadAllModels(location.search));
      } else {
        dispatch(loadAllModels(`${location.search}&all=true`));
      }

      isAddModelsLoaded && dispatch(addModelsIdle());
      isEditModelsLoaded && dispatch(editModelsIdle());
      if (isLoadedDeleteModel) {
        setDeleteModal(false);
        dispatch(deleteModelssIdle());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isAddModelsLoaded, isEditModelsLoaded, isLoadedDeleteModel]);

  useEffect(() => {
    if (!isAddModal) {
      dispatch(loadOneModels(modelId));
    }
    dispatch(loadAllUsers());
  }, [dispatch, isAddModal, modelId]);

  useEffect(() => {
    if (refImage.current) {
      refImage.current.style.minHeight = '111px';
      if (!isMobile) {
        refImage.current.style.minWidth = '400px';
        refImage.current.style.minHeight = '111px';
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refImage?.current, isMobile]);

  useEffect(() => {
    setIsDisabledSaveButton(
      !(titleModal && (typeModal.key === InitTypeModalEnum.ANY_LOGIC || link)),
    );
  }, [link, titleModal, typeModal]);

  useEffect(() => {
    if (isLoadingAddImages) {
      setImage(addImages);
    } else if (isLoadingDeleteImages) {
      setImage(null);
    }
  }, [addImages, isLoadingAddImages, isLoadingDeleteImages]);

  useEffect(() => {
    if (!isAddModal && isLoadedOneModels) {
      const newDataVers: Item = oneModels?.versions?.reduce(
        (acc: any, item) => ({
          ...acc,
          [item.id]: {
            id: item.id,
            description: item.description,
            version: item.version,
            date: formatDate(item.updated_at),
          },
        }),
        {},
      );
      setTitleModal(oneModels.name);
      setDescription(oneModels.description);
      setInstruction(oneModels.manual);
      setLink(oneModels.service_url);
      setTypeModal(
        userInit.view_types_model.find(
          (item) => item.key === oneModels.model_type,
        ),
      );
      setImage(oneModels.files.length > 0 ? oneModels.files[0] : null);
      setVersionInfo(newDataVers);
      setUserModelData(oneModels?.users);
    } else if (isAddModal && isLoadedOneModels) {
      setImage(null);
      setUserModelData([]);
    }
  }, [isAddModal, isLoadedOneModels, oneModels, userInit]);

  const clickAddVersion = useCallback(() => {
    const newId = Math.random() * 100;
    const dataInfo = Object.values(versionInfo);
    const newData: any = {
      id: String(newId),
      description: '',
      version:
        dataInfo.length === 0
          ? 1.1
          : dataInfo[0].version
          ? (Number(dataInfo[0].version) + 0.1).toFixed(1)
          : null,
      isNew: true,
      date: intlFormat(new Date(), {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }),
    };
    setVersionInfo((prev) => ({
      [newId]: newData,
      ...prev,
    }));
  }, [versionInfo]);

  const handleFiles = useCallback(
    (file) => {
      const fd = new FormData();
      fd.append('file', file[0]);
      dispatch(loadAddImages(fd));
    },
    [dispatch],
  );

  const handleTrashVersion = useCallback(
    (id: string) => {
      const newVersion = { ...versionInfo };
      delete newVersion[id];
      setVersionInfo(newVersion);
    },
    [versionInfo],
  );

  const dropImage = useMemo(() => {
    return isPendingAddImages ? (
      <Loader />
    ) : image ? (
      <div className={cx('AddModal__containerImage')}>
        <div className={cx('AddModal__deleteImage')}>
          <IconClose
            onClick={() =>
              !isPendingDeleteImages && dispatch(loadDeleteImages(image?.id))
            }
            className={cx('AddModal__iconCloseImage')}
          />
        </div>
        <img
          className={cx('AddModal__image')}
          src={`${process.env.REACT_APP_STATIC_URL}/${image?.path}`}
        />
      </div>
    ) : (
      <DragNDropField
        ref={refImage}
        multiple={false}
        onDropFiles={(file) => handleFiles(file)}
        accept=".jpg,.jpeg,.png"
      >
        <div className={cx('AddModal__dragFieldContainer')}>
          <Text className={cx('AddModal__textDrag')} view="secondary" size="s">
            Кликните или перетащите изображение в эту область для загрузки
          </Text>
        </div>
      </DragNDropField>
    );
  }, [dispatch, handleFiles, image, isPendingAddImages, isPendingDeleteImages]);

  const handleAddModal = useCallback(() => {
    const newVersion = Object.values(versionInfo)
      .filter((item) => item.version)
      .map(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ({ date, isNew, ...item }) => {
          if (isNew) {
            return {
              description: item.description,
              version: Number(item.version),
            };
          } else {
            return { ...item, version: Number(item.version) };
          }
        },
      );
    const newIserModel = userModelData.map((item) => item.id);
    const data = {
      name: titleModal,
      description: description,
      model_type: typeModal.key,
      service_url: link,
      versions: newVersion,
      file_ids: image ? [image.id] : [],
      user_ids: newIserModel,
      manual: instruction,
    };
    if (isAddModal) {
      dispatch(loadAddModels(data));
    } else {
      dispatch(loadEditModels(modelId, data));
    }
  }, [
    versionInfo,
    userModelData,
    titleModal,
    description,
    typeModal.key,
    link,
    image,
    isAddModal,
    dispatch,
    modelId,
    instruction,
  ]);

  if ((!isLoadedOneModels && !isAddModal) || !isLoadedAllUser)
    return <CenterLoader />;
  return (
    <div className={cx('AddModal', className)}>
      <div className={cx('AddModal__fixedTitle')}>
        <div className={cx('AddModal__title')}>
          {isMobile && (
            <Button
              className={cx('AddModal__buttonCloseMobile')}
              iconSize="s"
              view="clear"
              onlyIcon
              iconLeft={IconBackward}
              onClick={() => setIsAddModal(false)}
            />
          )}
          <Text className={cx('AddModal__data')} weight="semibold">
            {isAddModal
              ? 'Добавление карточки модели'
              : 'Редактирование карточки модели'}
          </Text>
          {!isMobile && (
            <Button
              className={cx('AddModal__buttonClose')}
              iconSize="s"
              view="clear"
              onlyIcon
              iconLeft={IconClose}
              onClick={() => setIsAddModal(false)}
            />
          )}
        </div>
        <div className={cx('AddModal__contentTabs')}>
          <Tabs
            value={valueTabs}
            onChange={({ value }) => setValueTabs(value)}
            items={tabsEditModal}
            getLabel={(item) => item.label}
            size="s"
            view="clear"
            className={cx('AddModal__tabs')}
          />
        </div>
      </div>
      <div className={cx('AddModal__contentModal')}>
        {valueTabs.id === EitTabsModalEnum.MODEL && (
          <div>
            <div className={cx('AddModal__infoModal')}>
              <div>
                <TextField
                  className={cx('AddModal__titleModal')}
                  onChange={({ value }) => {
                    setTitleModal(value);
                  }}
                  id="tableField"
                  value={titleModal}
                  size="s"
                  required
                  label="Наименование модели"
                />
                <div>
                  <Select
                    className={cx('AddModal__typeModal')}
                    onChange={({ value }) => {
                      if (value.key === InitTypeModalEnum.ANY_LOGIC) {
                        setLink(null);
                      }
                      setTypeModal(value);
                    }}
                    id="typeField"
                    items={userInit?.view_types_model}
                    value={typeModal}
                    getItemLabel={(item) => item.name}
                    getItemKey={(item) => item.key}
                    size="s"
                    label="Тип модели"
                  />
                </div>
              </div>
              <div>
                {!isMobile && (
                  <>
                    <Text
                      size="s"
                      view="secondary"
                      className={cx('AddModal__textImage')}
                    >
                      Изображение
                    </Text>
                    {dropImage}
                  </>
                )}
              </div>
            </div>
            {typeModal.key !== InitTypeModalEnum.ANY_LOGIC && (
              <TextField
                className={cx('AddModal__link')}
                onChange={({ value }) => {
                  setLink(value);
                }}
                id="Link"
                value={link}
                required
                size="s"
                label="URL"
                width="full"
              />
            )}
            <TextField
              className={cx('AddModal__description')}
              onChange={({ value }) => {
                setDescription(value);
              }}
              id="Link"
              value={description}
              placeholder="Введите описание модели"
              size="s"
              label="Описание"
              type="textarea"
              width="full"
              rows={4}
            />
            <TextField
              className={cx('AddModal__description')}
              onChange={({ value }) => {
                setInstruction(value);
              }}
              id="manual"
              value={instruction}
              placeholder="Введите инструкцию по запуску модели и указанию значений параметров запуска"
              size="s"
              label="Инструкция по использованию"
              type="textarea"
              width="full"
              rows={4}
            />
            {isMobile && (
              <div className={cx('AddModal__imageContent')}>
                <Text
                  size="s"
                  view="secondary"
                  className={cx('AddModal__textImage')}
                >
                  Изображение
                </Text>
                {dropImage}
              </div>
            )}
            <div className={cx('AddModal__history')}>
              <Text weight="semibold">История версий</Text>
              <Text
                size="s"
                view="link"
                cursor="pointer"
                onClick={() => clickAddVersion()}
              >
                Добавить версию
              </Text>
            </div>
            {Object.values(versionInfo).map((item, index) => (
              <div
                className={cx('AddModal__versions', {
                  AddModal__versions_padding:
                    Object.values(versionInfo).length - 1 !== index,
                })}
                key={item.id}
              >
                <div className={cx('AddModal__rowVersion')}>
                  <div className={cx('AddModal__contentVersionRow')}>
                    <TextField
                      className={cx('AddModal__fieldVersion')}
                      onChange={({ value }) => {
                        !isNaN(Number(value)) &&
                          setVersionInfo((prev) => {
                            const newVers = { ...prev };
                            newVers[item.id].version = value;
                            return newVers;
                          });
                      }}
                      id="version"
                      value={
                        versionInfo[item.id].version
                          ? String(versionInfo[item.id].version)
                          : ''
                      }
                      size="xs"
                    />
                    <IconTrash
                      onClick={() => handleTrashVersion(item.id)}
                      className={cx('AddModal__iconTrashVers')}
                    />
                  </div>
                  <div className={cx('AddModal__dateUpdate')}>
                    <Text size="xs" view="secondary">
                      Дата обновления:
                    </Text>
                    <Text className={cx('AddModal__dateChange')} size="xs">
                      {item.date}
                    </Text>
                  </div>
                </div>
                <TextField
                  className={cx('AddModal__dateDescription')}
                  onChange={({ value }) => {
                    setVersionInfo((prev) => {
                      const newText = { ...prev };
                      newText[item.id].description = value;
                      return newText;
                    });
                  }}
                  id="Link"
                  value={versionInfo[item.id].description}
                  size="s"
                  type="textarea"
                  width="full"
                  rows={3}
                />
              </div>
            ))}
          </div>
        )}
        {valueTabs.id === EitTabsModalEnum.USER && (
          <UserAddModal
            userModelData={userModelData}
            setUserModelData={setUserModelData}
            allUsers={allUsers}
            userInit={userInit}
          />
        )}
      </div>

      <div className={cx('AddModal__save')}>
        <Button
          onClick={() => {
            setIsAddModal(false);
          }}
          label="Отмена"
          size="s"
          view="ghost"
          className={cx('AddModal__buttonDelete', 'AddModal__buttonCancel')}
        />
        {!isAddModal && (
          <Button
            onClick={() => {
              setDeleteModal(true);
            }}
            label="Удалить"
            size="s"
            view="ghost"
            className={cx('AddModal__buttonDelete')}
          />
        )}
        <Button
          onClick={handleAddModal}
          size="s"
          label={isAddModal ? 'Добавить' : 'Сохранить'}
          disabled={isDisabledSaveButton}
          className={cx('AddModal__buttonSave')}
          loading={isAddModal ? addModelsPending : editModelsPending}
        />
      </div>
      {!isAddModal && (
        <Modal
          position="center"
          isOpen={deleteModal}
          hasOverlay
          className={cx('AddModal__modalDelete')}
        >
          <CloseModal
            title="Удаление карточки модели"
            text={`Вы действительно хотите удалить карточку "${oneModels.name}" ?`}
            setModalOpenBlocking={setDeleteModal}
            textButton="Удалить"
            handleClick={() => dispatch(loadDeleteModels(oneModels.id))}
            loading={isPendingDeleteModel}
          />
        </Modal>
      )}
    </div>
  );
};

export default AddModal;
